//Forced to name .js because .mjs raises a bug when importing awesome icones
//"use strict";

//Import fontawesome in vanilla JS :
// Ref : https://dev.to/joeattardi/how-to-use-font-awesome-icons-in-a-vanilla-javascript-project-5b5b
/*OBSOLETE LANG ARE MANAGED AT ACTIVITY LEVEL AND IN VUE FOR SEQUENCES
import { EledaMessagesFR } from "../lang/EledaMessagesFR";
import { EledaMessagesEN } from "../lang/EledaMessagesEN";
import { EledaMessagesIT } from "../lang/EledaMessagesIT";
import { EledaMessagesDE } from "../lang/EledaMessagesDE";
*/
import { getEledaMessage } from "../lang/EledaMessages";
/** Class representing a sequence of activities.
 * @property {Integer} nbActivities                - Number of generatd Activities, the student has to achieve
 * @property {JSON} options                       - JSON that store options
 */
export class Sequence {
  activities;
  nbActivities;
  examMode;
  feedbackProvided;
  solutionProvided;
  reviewProvided;
  calledFromMoodle;

  constructor(nbActivities = 1, options) {
    this.activities = [];
    this.nbActivities = nbActivities;
    //Get options and set Sequence attributes
    this.maxSequenceGrade = options.maxSequenceGrade
      ? options.maxSequenceGrade
      : 100;
    this.feedbackProvided = !options.examMode; //set feedbackProvided to same value to solution. La différence était faite avant entre feedback et solution mais cela n'a aucun sens.
    this.solutionProvided = !options.examMode;

    // this.feedbackProvided = options.solutionProvided; //set feedbackProvided to same value to solution. La différence était faite avant entre feedback et solution mais cela n'a aucun sens.
    // this.solutionProvided = options.solutionProvided;
    this.reviewProvided = options.reviewProvided;
    this.calledFromMoodle = options.calledFromMoodle;

    //Retrieve lang of activity which is set before
    //this.setLang(window.eledaGlobalSettings.activityCurrentLang);
  }

  getActivity() {
    return this.activity;
  }

  addActivity(activity) {
    this.activities.push(activity);
  }

  isFeedbackProvided() {
    return this.feedbackProvided;
  }

  isExamMode() {
    return this.examMode;
  }

  isSolutionProvided() {
    return this.solutionProvided;
  }

  isReviewProvided() {
    return this.reviewProvided;
  }

  getNbActivities() {
    return this.nbActivities;
  }

  getFeedback() {
    return this.feedbacks;
  }

  getDisplaySolution() {
    return this.displaySolution;
  }

  changeLanguage() {
    this.nodeCheckAnswersButton.innerHTML = getEledaMessage("submitBtn");
    this.nodeNextActivityButton.innerHTML = getEledaMessage("nextActBtn");
    this.activity.updateHtmlNodeAttempts();
  }

  /*OBSOLETE
  setLang(lang) {
    switch (lang) {
      case "fr":
        window.EledaMessages = EledaMessagesFR;
        break;
      case "de":
        window.EledaMessages = EledaMessagesDE;
        break;
      case "it":
        window.EledaMessages = EledaMessagesIT;
        break;
      default:
        window.EledaMessages = EledaMessagesEN;
        break;
    }
  }*/
}
